import { GridSortModel } from "@mui/x-data-grid";
import { Dayjs } from "dayjs";
import { DealerAccount } from "../../../api/dealer/types";
import { OrdersResponse } from "../../../api/orders/orderInterfaces";

export type TabDownloadState = {
  isDownloading: boolean;
  isDownloadFailed: boolean;
};

export type AllOrdersState = {
  accountId: string;
  language: string;
  allOrders: OrdersResponse[];
  isLoading: boolean;
  isDownloading: boolean;
  isDownloadFailed: boolean;
  downloadStates: {
    allOrders: TabDownloadState;
    unsubmittedOrders: TabDownloadState;
  };
  isTechnicalError: boolean;
  isAuthorizedError: boolean;
  isAuthenticationError: boolean;
  filters: AllOrdersFilters;
  isFilterApplied: boolean;
  selectedAccounts: DealerAccount[];
  currentPage: number;
  pageRowSize: number;
  totalOrders: number;
  sortModel: GridSortModel;
  tabIndex: number;
  statusCount: OrderStatusCount;
};

export type OrderStatusCount = {
  allOrders: number;
  unsubmittedOrders: number;
};

export type AuthState = {
  isAuthenticated?: boolean;
  accessToken?: string;
};

export enum OrderClient {
  UI = "UI",
  PRISM = "PRISM",
  PMLINK = "PMLINK",
  SYSTEM = "SYSTEM",
  JDPOINT = "JDPOINT",
  POLL = "POLL",
  UNKNOWN_PRISM = "UNKNOWN",
}

export type OrderRow = {
  accountId?: string;
  orderNumber?: string;
  promotion: string[];
  investigation?: string[];
  generatedFrom?: string;
  client?: OrderClient;
  dealerReference?: string;
  submittedBy?: string;
  orderType?: string;
  orderStatus?: string;
  dateTimeSubmitted?: string;
  dateTimeCreated?: string;
  isCreditCheckNotOk?: boolean;
  id: string;
  path: string[];
};

export type AllOrdersFilters = {
  accountIds?: string[];
  orderTypes?: string[];
  orderNumber?: string;
  promotion?: string;
  dealerReference?: string;
  orderStatuses?: string[];
  orderCreationDateTo?: Dayjs;
  orderCreationDateFrom?: Dayjs;
  orderSubmittedDateFrom?: Date;
  orderSubmittedDateTo?: Date;
};

export type AllOrdersRequestBody = {
  accountId: string[];
  pageNumber: number;
  size: number;
  sortDirection?: string | null;
  sortField?: string | null;
  orderNumber?: string;
  dealerReference?: string;
  promotionId?: string;
  orderTypes?: string[];
  orderStatuses?: string[];
  orderCreationDateFrom?: Date;
  orderCreationDateTo?: Date;
  latestOrderCreationDateFrom?: string;
  latestOrderCreationDateTo?: string;
  orderSubmittedDateFrom?: string;
  orderSubmittedDateTo?: string;
};

export enum OrderStatus {
  UNSUBMITTED = "UNSUBMITTED",
  SUBMITTED = "SUBMITTED",
  CANCELLED = "CANCELLED",
  COMPLETED = "COMPLETED",
  ON_HOLD = "ON_HOLD",
  IN_PROCESS = "IN_PROCESS",
}
export enum OrderType {
  EMERGENCY_ORDER = "EMERGENCY_ORDER",
  STOCK_ORDER = "STOCK_ORDER",
  PROMOTION_ORDER = "PROMOTION_ORDER",
}
